import { Box, Card, Stack, Text } from "@vinomofo/components";
import { LinkTo, StorefrontImage } from "../../../types";
import { PropsWithChildren } from "react";

import { Button } from "../../button";
import { GatsbyImage } from "gatsby-plugin-image";
import { Link } from "../../link";

export interface CollectionBannerProps {
  backgroundImage: StorefrontImage;
  headerImage: StorefrontImage;
  navigationName: string;
  navigationColor: string;
  title?: string;
  bodyText?: string;
  primaryCta: {
    buttonColour: string;
    buttonBorderColor: string;
    buttonTextColor: string;
    label: string;
    linkTo: LinkTo;
  };
}

export const CollectionBanner = ({
  backgroundImage,
  headerImage,
  title,
  bodyText,
  children,
  primaryCta,
}: PropsWithChildren<CollectionBannerProps>): JSX.Element => {
  const ctaLink = primaryCta?.linkTo?.slug || primaryCta?.linkTo?.url;
  const ctaTarget = primaryCta?.linkTo?.target === "New Tab" ? "_new" : "_self";
  return (
    <Box
      height={["auto", "auto", "540px"]}
      position={["static", "static", "relative"]}
    >
      <Box position="relative" height="100%">
        <Box
          borderRadius={["4px 4px 0 0", "4px"]}
          overflow="hidden"
          position="absolute"
          top="0"
          right="0"
          bottom="0"
          left="0"
        >
          <GatsbyImage
            image={backgroundImage}
            objectFit="cover"
            objectPosition="center center"
            style={{
              width: "100%",
              height: "100%",
            }}
            alt=""
          />
        </Box>
        <Box
          position="relative"
          minHeight={["280px", "340px"]}
          padding="2em 2em 3em"
        >
          {children}
        </Box>
      </Box>
      <Card
        position={["relative", "relative", "absolute"]}
        top={[0, 0, "2em"]}
        right={[0, 0, "2em"]}
        margin={[0, "-2em 2em 0", 0]}
        width={["auto", "auto", "355px"]}
        minHeight={["auto", "auto", "540px"]}
        bg="white"
        padding={["20px", "30px", "40px"]}
        alignItems="center"
      >
        <Stack space={3}>
          {headerImage && (
            <Box maxWidth={220} mx="auto">
              <GatsbyImage image={headerImage} alt={`Image of ${title}`} />
            </Box>
          )}
          {bodyText && (
            <Text variant="sm" textAlign="center">
              {bodyText}
            </Text>
          )}
          {ctaLink && (
            <Box textAlign="center" fontWeight={500}>
              <Button
                as={Box}
                to={ctaLink}
                target={ctaTarget}
                ghost
                color={primaryCta.buttonTextColor || "primary"}
                isLink
              >
                {primaryCta.label}
              </Button>
            </Box>
          )}
        </Stack>
      </Card>
    </Box>
  );
};
